"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var namespace_1 = __importDefault(require("../namespace"));
namespace_1.default.namespace.extend('url', {
    /*
        Returns URL vars.
        @param name is the var we want to get. If not specified, an array of all vars is returned.
        @returns a var we want to get or an array of all vars

        remarks: There is no special test for this method. It has already been "tested" through various implementations in "real life" of 2010/11
    */
    getVars: function (name) {
        var vars = {};
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for (var i = 0; i < hashes.length; i++) {
            var hash = hashes[i].split('=');
            vars[hash[0]] = hash[1];
        }
        if (name) {
            return vars[name];
        }
        else {
            return vars;
        }
    },
    /*
        Sets all URL-vars that are considered appropriate for all visuals that have the same name (e.g wahlen):

                e.g:	if we have apa.config.section defined and the URL-vars contain 'apaSection' the contents of the url-var overwrites the apa.config - parameter.

        USAGE: define startup-params via the URL (which page of a tool to start,...)
    */
    getOverallParams: function (visuals) {
        var _this = this;
        var urlVars = this.getVars();
        Object.keys(urlVars).forEach(function (el) {
            if (!el.split('_')[1]) { // params that split with _ are frame-specific and are ignored in the overall-Params;
                visuals.forEach(function (visual) {
                    if (el.indexOf('apaview') > -1) {
                        var config = namespace_1.default.visual[visual].config;
                        var newParams = {};
                        var tParamsArr = urlVars[el].split('-'); // params are split by '-'
                        tParamsArr.forEach(function (param) {
                            var paramPair = param.split(':'); // the value is split from the key by ':'
                            var tAttribute = paramPair[0].toString();
                            var tValue = paramPair[1].toString();
                            // set debugmode to true if it is set within the apaview params as debugmode:true
                            if (tAttribute.indexOf('debugmode') > -1 && tValue == 'true') {
                                namespace_1.default.debugmode = true;
                            }
                            newParams[tAttribute] = _this.getVal(tValue, config.view[tAttribute], tAttribute);
                        });
                        namespace_1.default.utils.extend(config.view, newParams);
                    }
                });
            }
        });
    },
    /*
        In case of array, parses the string to array
    */
    getVal: function (value, origValue, attribute) {
        if (Array.isArray(origValue)) { // value is an array
            if (value == '')
                return [];
            var returnArr = value.split(',');
            return returnArr;
        }
        else if (this.isInt(origValue)) { // value is an int
            try {
                return parseInt(value, 10);
            }
            catch (e) {
                console.warn('deeplink(' + attribute + ') has to be int');
            }
        }
        else if (this.isFloat(origValue)) { // value is an float
            try {
                return parseFloat(value);
            }
            catch (e) {
                console.warn('deeplink(' + attribute + ') has to be float');
            }
        }
        else { // value is string or bool
            if (value === 'true') {
                return true;
            }
            else if (value === 'false') {
                return false;
            }
            return value;
        }
    },
    isInt: function (n) {
        return Number(n) === n && n % 1 === 0;
    },
    isFloat: function (n) {
        return Number(n) === n && n % 1 !== 0;
    },
    getFrameParams: function (frameId) {
        var urlVars = this.getVars();
        Object.keys(urlVars).forEach(function (el) {
            if (el == ('apaview_' + frameId)) { // only changing the view-params is allowed via url	, this time we take only frame-specific params
                var newParams = {};
                var tParamsArr = urlVars[el].split('-'); // params are split by '-'
                tParamsArr.forEach(function (param) {
                    var paramPair = param.split(':'); // the value is split from the key by ':'
                    newParams[paramPair[0].toString()] = paramPair[1].toString();
                });
                namespace_1.default.utils.extend(namespace_1.default.items[frameId].config.view, newParams);
            }
        });
    }
});
